
import { Location } from 'react-router-dom';

export enum RoutineSubmitSource {
  AssetCard = 'asset-card',
  RoutinesList = 'routines-list',
}

export const ALL_ACTIVITIES_QUERY_VALUE = 'activities-all';
export const ALL_ACTIVITIES_QUERY_KEY = `from=${ALL_ACTIVITIES_QUERY_VALUE}`;

export const assetPaths = {
  root: 'assets',
};

export function isActivityOrEditPage(location: Location<any>): boolean {
  return (
    location.pathname.includes('/activity/') ||
    location.pathname.includes('/edit') ||
    location.pathname.includes('/detail') ||
    location.pathname.includes('/routines') ||
    location.pathname.includes('/files')
  );
}

export function isActivitiesParent(location: Location<any>): boolean {
  return location.pathname.startsWith('/activities/');
}
